
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(68313|70527)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
